import { isJDiwork } from '@utils';

/**
 * goBack
 * @param rootStore
 * @param options
 */
export const goBack = {
  get visible() {
    return this.rootStore.pageStore.query?.adt !== 'wf'
  },
  get enable() {
    return this.visible
  },
  async doAction(rootStore: any, options: any = {}) {
    const { pageStore = {} } = rootStore;
    try {
      const cardStoreKey = Object.keys(rootStore).find(key => rootStore[key]?.storeType === 'CardStore')
      const mode = rootStore[cardStoreKey]?.uiState;
      if (mode === 'edit' || mode === 'add') {
        await rootStore.utils.confirm({ title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B8003F', '确认取消编辑?'), content: lang.templateByUuid('UID:P_CORE-YNF-FE_19201FC605900003', '您将取消编辑并回退'), ...options.confirmOptions });
      }
      setTimeout(() => {
        pageStore.goBack({ params: options });
        rootStore.eventBus.emitParallel(rootStore, 'goBack', null, this);
      });
    } catch (err: any) {
      return Promise.reject(err);
    }
  }
}

/**
 * closeWin
 * @param rootStore
 * @param options
 */
export async function closeWin(rootStore: any, options: any = {}) {
  try {
    if (window.mtl) {
      window.closeYnfBill?.()
      window.mtl.navigateBack();
    } else if (isJDiwork()) {
      window.jDiwork.closeWin();
    } else {
      window.close();
    }
  } catch (err: any) {
    return Promise.reject(err);
  }
}

/**
 * refresh
 * @param rootStore
 * @param options
 */
export async function refresh(rootStore: any, options: any = {}) {
  const { pageStore = {} } = rootStore;
  try {
    setTimeout(() => {
      pageStore.refresh();
    });
  } catch (err: any) {
    return Promise.reject(err);
  }
}

/**
 * bNeedRefresh
 * @param rootStore
 * @param options
 */
export async function bNeedRefresh(rootStore: any, options: any = {}) {
  const { pageStore = {} } = rootStore;
  try {
    setTimeout(() => {
      pageStore.bNeedRefresh = true;
    });
  } catch (err: any) {
    return Promise.reject(err);
  }
}
